export { ProductsStore } from './ProductsStore';

import { ProductsStoreAll } from './ProductsStoreAll';

export default {
    productsStoreAll: new ProductsStoreAll()
};
